
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { useStore } from '@/store'
import QInput from 'quasar/src/components/input/QInput.js';import QForm from 'quasar/src/components/form/QForm.js';import QBtn from 'quasar/src/components/btn/QBtn.js';
import * as otpService from '@/services/line-web-loyalty-bff/v1/otp'
import { alertMessageError } from '@/model/alert-options.model'
import { StepEditMobile } from '@/model/step-edit-mobile.model'
import { modalOptionsExceededRateLimit, modalOptionsTooManyRequest, modalTokenExpired } from '@/model/modal-options.model'

@Options({
  components: {
    QInput,
    QForm,
    QBtn,
  },
})
export default class NewMobile extends Vue {
  @Prop() mobileNumber!: string

  store = useStore()
  private isSubmit = false
  private newMobileNumber = ''

  mounted() {
    this.setNewMobileNumber()
    this.validateIsSumit()
  }

  validateIsSumit() {
    this.isSubmit =
      this.newMobileNumber?.length === 10 && this.newMobileNumber !== this.mobileNumber
        ? true
        : false
    this.isSubmit = this.validationAllowMobileNumber(this.newMobileNumber)
  }

  setNewMobileNumber() {
    this.newMobileNumber = this.store.state.modalEditMobile.newMobileNumber ?? ''
  }

  onChangeNewMobileNumber(val: string, ref: any) {
    this.newMobileNumber = val?.replace(/[^0-9]/g, '')
    this.isSubmit = val?.length === 10 && val !== this.mobileNumber ? true : false
    this.isSubmit = this.validationAllowMobileNumber(val)

    return this.validationNewMobileNumber(val)
      ? ref.newMobileNumberInput.validate()
      : ref.newMobileNumberInput.resetValidation()
  }

  onRulesNewMobileNumber(val: string) {
    return (
      !val ||
      !this.validationNewMobileNumber(val) ||
      'กรุณากรอกเบอร์โทรศัพท์มือถือที่ไม่ตรงกับเบอร์ปัจจุบัน'
    )
  }

  validationNewMobileNumber(val: string) {
    return val === this.mobileNumber
  }

  validationAllowMobileNumber(val: string) {
    const pattern = /^0(([4-5,7-9][0-9]{8})|(6[1-6][0-9]{7}))$/
    return pattern.test(val)
  }

  handleAlertMessage(statusCode: number) {
    this.store.dispatch('alertMessage/onOpen', alertMessageError(statusCode))
    setTimeout(() => this.store.dispatch('alertMessage/onClose'), 3000)
  }

  async submitForm() {
    this.store.commit('modalEditProfile/updateIsLoadingSpinner', true)
    const token = this.store.state.lineInfo.idToken
    if (this.isSubmit && token) {
      const l1Token = this.store.state.modalEditMobile.l1Token
      const requestBody = { mobile_no: '66' + this.newMobileNumber.substring(1), l1_token: l1Token }
      const result = await otpService.sendOtp(token, requestBody, 'L2')

      const statusCode = result?.json?.code
      if (statusCode === 200) {
        const { ref_code: refCode } = result?.json?.data
        this.store.commit('modalEditMobile/updateNewMobileNumber', this.newMobileNumber)
        this.store.commit('modalEditMobile/updateLevel', 'L2')
        this.store.commit('modalEditMobile/updateOtpRefCode', refCode)
        this.store.commit('modalEditMobile/updateStep', StepEditMobile.OTP_VERIFICATION)
      } else if (statusCode === 401) {
        const { error_name: errorName } = result?.json?.error
        if (errorName === 'token_expired') {
          this.store.dispatch(
            'modalNotification/onOpenTokenExpired',
            modalTokenExpired(() => {
              this.store.dispatch('modalEditMobile/onResetStep')
              this.store.dispatch('modalEditMobile/onOpen')
              this.store.dispatch('modalNotification/onCloseTokenExpired')
            })
          )
        } else {
          this.handleAlertMessage(statusCode)
        }
      } else if (statusCode === 429) {
        const { error_name: errorName } = result?.json?.error
        if (errorName === 'exceeded_rate_limit') {
          this.store.dispatch(
              'modalNotification/onOpen',
              modalOptionsExceededRateLimit(this.store, true)
            )
        } else if (errorName === 'too_many_requests_error') {
          this.store.dispatch('modalNotification/onOpen', modalOptionsTooManyRequest(this.store))
        } else {
          this.handleAlertMessage(statusCode)
        }
      } else {
        this.handleAlertMessage(statusCode)
      }
    }
    this.store.commit('modalEditProfile/updateIsLoadingSpinner', false)
  }
}
